import { useWorkspace, useWorkspaceLoading } from '~workspace/states/workspace'
import { View } from './view'

const WorkspaceInfo = () => {
  const workspace = useWorkspace()
  const loading = useWorkspaceLoading()

  return (
    <View
      loading={loading}
      workspace={workspace}
    />
  )
}

export { WorkspaceInfo }
export default WorkspaceInfo
